export function calculateImageDimension(
  width: number,
  height: number,
  options: { maxWidth?: number; maxHeight?: number } = {},
): [number, number, number] {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const maxWidth = options.maxWidth
    ? options.maxWidth <= 1
      ? screenWidth * options.maxWidth
      : options.maxWidth
    : screenWidth - 150;
  const maxHeight = options.maxHeight
    ? options.maxHeight <= 1
      ? screenHeight * options.maxHeight
      : options.maxHeight
    : screenHeight * 0.25;

  let aspectLimit = Math.min(maxWidth / width, maxHeight / height);
  if (aspectLimit >= Number.POSITIVE_INFINITY) {
    aspectLimit = 1;
  }

  return [width * aspectLimit, height * aspectLimit, width / height || 1];
}

export async function getImageDimension(url: string): Promise<[number, number, number]> {
  return new Promise<[number, number, number]>((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      const aspectRatio = Number.parseFloat((img.naturalWidth / img.naturalHeight).toFixed(2));
      resolve([img.naturalWidth, img.naturalHeight, aspectRatio || 1]);
    };
    img.onerror = (error) => {
      reject(error);
    };

    img.crossOrigin = 'anonymous';
    img.src = url;
  });
}
